import { DataTransferService } from "./common/data-transfer.service";
import { DicomService } from "./dicom/dicom.service";
import { EncrypDepcrypService } from "./encryption/encryp-depcryp.service";
import { ExamInfoService } from "./exam-info/exam-info.service";
import { ExamResultService } from "./exam-result/exam-result.service";
import { AppMenuService } from "./menu/menu.service";
import { OpenAiService } from "./open-ai/open-ai.service";
import { ReportService } from "./report/report.service";
import { CustomNavigationService } from "./router/custom-navigation.service";
import { RouterExtService } from "./router/router-ext.service";
import { CustomerSiteScopeService } from "./scope/customer-site-scope.service";
import { SignalrService } from "./signalRs/signalr.service";
import { LocalStorageService } from "./storage/local-storage.service";
import { BrowserInfoService } from "./utility/browser-info.service";
import { TimeLimitService } from "./utility/time-limit.service";
import { UtilityService } from "./utility/utility.service";

export const services: any[] = [
  DicomService,
  ExamResultService,
  ExamInfoService,
  ReportService,
  OpenAiService,
  UtilityService,
  EncrypDepcrypService,
  TimeLimitService,
  DataTransferService,
  AppMenuService,
  LocalStorageService,
  RouterExtService,
  CustomNavigationService,
  SignalrService,
  BrowserInfoService,
  CustomerSiteScopeService,
];

export * from "./common/data-transfer.service";
export * from "./dicom/dicom.service";
export * from "./encryption/encryp-depcryp.service";
export * from "./exam-info/exam-info.service";
export * from "./exam-result/exam-result.service";
export * from "./menu/menu.service";
export * from "./open-ai/open-ai.service";
export * from "./report/report.service";
export * from "./router/custom-navigation.service";
export * from "./router/router-ext.service";
export * from "./scope/customer-site-scope.service";
export * from "./signalRs/signalr.service";
export * from "./storage/local-storage.service";
export * from "./utility/browser-info.service";
export * from "./utility/time-limit.service";
export * from "./utility/utility.service";
